<div class="notification-bar-container zone-dark">
  <div class="notification-bar-main">
    <div class="notification-bar-icon" *ngIf="icon">
      <lui-avatar [size]="32" [color]="iconColor">
        <mat-icon [svgIcon]="icon"></mat-icon>
      </lui-avatar>
    </div>
    <div class="notification-bar-message" [innerHTML]="message"></div>
  </div>

  <button luiButton (click)="primaryAction()" *ngIf="primaryButtonText">
    {{ primaryButtonText }}
  </button>
  <button
    luiIconButton
    size="sm"
    class="notification-bar-dismiss"
    (click)="dismiss()"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
